import esMessages from '../locales/tr_TR';

const EsLang = {
  messages: {
    ...esMessages,
  },
  locale: 'tr-TR',
};
export default EsLang;
